import { NavLink } from "react-router-dom";

const tabClass = ({ isActive }) =>
  `rounded-lg px-4 py-2 text-sm font-semibold ${
    isActive
      ? "bg-fairway-600 text-white"
      : "border border-gray-200 text-gray-600 hover:bg-fairway-50"
  }`;

export default function AdminNav() {
  return (
    <div className="mb-6 flex gap-2">
      <NavLink to="/admin/orders" className={tabClass}>
        Orders
      </NavLink>
      <NavLink to="/admin/memberships" className={tabClass}>
        Memberships
      </NavLink>
    </div>
  );
}
